module.exports = __webpack_public_path__ + "bathroom.png?67d6e54d6fe8f018e6afd37bda1b62b5";